<template>
  <div class="container">
    测试页面
    <wsTest></wsTest>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import wsTest from './wsTest';
export default {
  name: 'test',
  components: {wsTest},
  data () {
    return {};
  },
  mounted () {
    this.setSubTitle('测试页面');
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style>

</style>
